import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["memberField", "organizationField"]

  connect() {
    this.toggle()
  }

  toggle(event) {
    const selectedType = event ? event.target.value : this.typeSelectValue

    // Hide all fields
    this.memberFieldTarget.style.display = 'none'
    this.organizationFieldTarget.style.display = 'none'

    // Clear the other field when switching
    if (selectedType === 'Member') {
      this.memberFieldTarget.style.display = 'block'
      this.clearField(this.organizationFieldTarget)
    } else if (selectedType === 'Organization') {
      this.organizationFieldTarget.style.display = 'block'
      this.clearField(this.memberFieldTarget)
    }
  }

  get typeSelectValue() {
    const typeSelect = this.element.querySelector('select[name*="created_by_type"]')
    return typeSelect ? typeSelect.value : ''
  }

  clearField(fieldElement) {
    const select = fieldElement.querySelector('select')
    if (select) {
      select.value = ''
    }
  }
}
